// Angular
import { Injectable, inject } from '@angular/core';
import { fetch } from '@nx/angular';

// Thirt party
import { createEffect, Actions, ofType } from '@ngrx/effects';

// Local file
import * as CommonActions from './common.actions';



@Injectable()
export class CommonEffects {
  private actions$ = inject(Actions);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommonActions.initState),
      fetch({
        id: () => 'init-common',
        run: () => CommonActions.loadCommonSuccess(),
        /* eslint-disable  no-empty-pattern */
        onError: ({}, error) => CommonActions.loadCommonFailure({ error }),
      })
    )
  );
}
